import { observer } from "mobx-react-lite";
import useAddDealNoteValidationSchema from "../../hooks/useAddDealNoteValidationSchema";
import useDealNoteCreate from "../../hooks/useDealNoteCreate";
import AddNote from "../AddNote";

function AddDealNote({ dealId }: { dealId: number }) {
    const createDealNote = useDealNoteCreate();
    const validationSchema = useAddDealNoteValidationSchema();

    return (
        <AddNote
            onSubmitNote={(text) => createDealNote(dealId, text)}
            validationSchema={validationSchema}
        />
    );
}

export default observer(AddDealNote);
